import { Suspense, useEffect, useLayoutEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import PageLoader from '@/components/PageLoader';

// Navbar/footer OLMAYAN, tek başına tam ekran sayfalar için sade kabuk
// (ör. /form/:id başvuru formları). Kendi zeminini sayfa (FormShell) çizer.

// FormBackdrop'un dış rengi — yükleme ekranı da bu zeminde görünsün diye
// burada, sayfa chunk'ı gelmeden uygulanır. Aksi hâlde yer tutucu site
// varsayılanında (#03060f) kalıyor, form gelince #03040a'ya atlıyordu.
const FORM_PAGE_BG = '#03040a';

const BareLayout = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' as ScrollBehavior });
  }, [pathname]);

  // useLayoutEffect: boyamadan ÖNCE çalışır → ilk kareden doğru renk.
  useLayoutEffect(() => {
    document.documentElement.style.setProperty('--page-bg', FORM_PAGE_BG);
    const meta = document.querySelector<HTMLMetaElement>(
      'meta[name="theme-color"]',
    );
    if (meta) meta.content = FORM_PAGE_BG;
  }, []);

  return (
    <Suspense fallback={<PageLoader full />}>
      <div data-page-content>
        <Outlet />
      </div>
    </Suspense>
  );
};

export default BareLayout;
